import { Text } from '@shopify/polaris';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-bottom">
                    <Text as="p" variant="bodySm">
                        © {new Date().getFullYear()} {import.meta.env.VITE_APP_NAME}. All rights reserved.
                    </Text>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
